import React, {useState} from 'react';
import {Menu} from 'antd';
import {ApiOutlined, BarChartOutlined, CreditCardOutlined, DeploymentUnitOutlined, LockFilled} from '@ant-design/icons';
import {useHistory} from 'react-router';
import {session} from "../../service/session";

const LOGO_REDIRECT_URL = process.env.REACT_APP_LOGO_REDIRECT_URL || "https://www.geokon.com";
const LOGO_DARK_URL = process.env.REACT_APP_LOGO_SMALL_URL || "https://storage.googleapis.com/geokon-public-assets/logo-dark-cropped.svg";
const LOGO_URL = process.env.REACT_APP_LOGO_SMALL_URL || "https://storage.googleapis.com/geokon-public-assets/logo.png";

const SideNav = () => {
    const history = useHistory();
    const hideDataPanel = process.env.REACT_APP_HIDE_DATA_PANEL === "true"
    const hideBillingInfo = process.env.REACT_APP_HIDE_BILLING_INFO === "true"

    // Map routes to selected menu tab
    const getSelected = () => {
        const path = history.location.pathname
        if (path.startsWith('/connections')) {
            return ['connections']
        } else if (path.startsWith('/devices') || path.startsWith('/device')) {
            return ['devices']
        } else if (path.startsWith('/billing')) {
            return ['billing']
        } else if (path.startsWith('/admin')) {
            return ['admin']
        } else if (path.startsWith('/data')) {
            return ['data']
        } else {
            return []
        }
    }
    history.listen((event: any) => {
        setSelectedKeys(getSelected)
    })
    const [selectedKeys, setSelectedKeys] = useState(getSelected());

    return (
        <div>
            {session.isDarkSession() ?
                <div style={{height: "32px", margin: "16px"}}>
                    <a href={LOGO_REDIRECT_URL} target="_blank" rel="noreferrer">
                        <img src={LOGO_DARK_URL}
                             style={{maxHeight: '36px'}}
                             alt="logo"/>
                    </a>
                </div>
                :
                <div style={{height: "32px", margin: "16px", zIndex: 99, position: "relative"}}>
                    <a href={LOGO_REDIRECT_URL} target="_blank" rel="noreferrer">
                        <img style={{maxHeight: '36px'}}
                             src={LOGO_URL} className="App-logo"
                             alt="logo"/>
                    </a>
                </div>
            }

            <Menu theme="light" mode="inline" selectedKeys={selectedKeys}>
                <Menu.Item key="devices" onClick={() => history.push('/devices')}>
                    <DeploymentUnitOutlined />
                    <span> Devices</span>
                </Menu.Item>
                <Menu.Item key="connections" onClick={() => history.push('/connections')}>
                    <ApiOutlined />
                    <span> Connections</span>
                </Menu.Item>
                {hideDataPanel ? null :
                    <Menu.Item key="data" onClick={() => history.push('/data')}>
                        <BarChartOutlined />
                        <span> Data</span>
                    </Menu.Item>
                }

                {(hideBillingInfo && !session.isAdminSession()) ? null :
                    <Menu.Item key="billing" onClick={() => history.push('/billing')}>
                        <CreditCardOutlined />
                        <span> Billing</span>
                    </Menu.Item>
                }

                {
                    session.isAdminSession() ?
                        <Menu.Item key="admin" style={{color:"red"}} onClick={() => history.push('/admin')}>
                            <LockFilled />
                            <span> Admin</span>
                        </Menu.Item> :
                    null
                }
            </Menu>
        </div>
    );
}

export default SideNav;